import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Rocket, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

export default function KickstartPopup() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("kz-popup-seen")) return;
    const id = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(id);
  }, []);

  const close = () => {
    sessionStorage.setItem("kz-popup-seen", "1");
    setShow(false);
  };
  const start = () => {
    close();
    window.__lenis?.scrollTo("#contact", { offset: -96 });
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="kickstart-popup"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#2B0A4E]/60 backdrop-blur-sm"
          onClick={close}
        >
          <motion.div
            initial={{ scale: 0.92, y: 32 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.95, y: 20 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            className="relative max-w-md w-full sketch-border bg-[#FDFBF5] p-8 sm:p-10 shadow-[10px_10px_0_#F2C230]"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="popup-close"
              onClick={close}
              aria-label="Close"
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-[#2B0A4E]/5 text-[#2B0A4E] flex items-center justify-center hover:bg-[#2B0A4E] hover:text-[#FDFBF5] transition-colors duration-300"
            >
              <X size={18} />
            </button>
            <span className="inline-flex items-center gap-2 font-mono-label text-[10px] tracking-[0.2em] uppercase bg-[#F2C230] text-[#2B0A4E] px-3 py-1.5 rounded-full">
              <Rocket size={13} /> {t("popup_tag")}
            </span>
            <h3 className="mt-5 font-serif-display font-bold text-3xl sm:text-4xl text-[#2B0A4E] leading-tight" data-testid="popup-title">
              {t("popup_h")}
            </h3>
            <p className="mt-4 text-sm sm:text-base text-[#5E4783] leading-relaxed">{t("popup_d")}</p>
            <button
              data-testid="popup-cta"
              onClick={start}
              className="mt-7 w-full sketch-border bg-[#2B0A4E] text-[#FDFBF5] px-6 py-4 font-mono-label text-xs tracking-[0.2em] uppercase flex items-center justify-center gap-2 hover:bg-[#3E116B] hover:-translate-y-0.5 transition-[transform,background-color] duration-300"
            >
              {t("popup_cta")} <ArrowRight size={15} />
            </button>
            <button
              data-testid="popup-dismiss"
              onClick={close}
              className="mt-3 w-full text-center font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#2B0A4E]/50 hover:text-[#2B0A4E] transition-colors duration-300"
            >
              {t("popup_no")}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
